import { ProfileService } from "@services/ProfileService";
import { useQuery } from "react-query";

export const ProfileQueryKey = "account";

export function useProfile() {
  return useQuery([ProfileQueryKey], ProfileService.get);
}
